import { render, staticRenderFns } from "./PortableText.vue?vue&type=template&id=571165fd"
import script from "./PortableText.vue?vue&type=script&lang=js"
export * from "./PortableText.vue?vue&type=script&lang=js"
import style0 from "./PortableText.vue?vue&type=style&index=0&id=571165fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports